<style lang="scss">
  @use "../../../assets/css/design-system/colors";

  thead {
    position: sticky;
    top: 0;

    &.include-gap {
      // spacing between thead & tbody
      &::after {
        content: "";
        display: block;
        padding-top: 0.75rem;
      }
    }
  }
</style>

<script>
  import { setContext } from "svelte";
  import { IS_HEAD } from "./table-context";

  setContext(IS_HEAD, true);

  export let zIndex = 0;
  export let includeGap = true;
</script>

<thead style={`z-index:${zIndex}`} class:include-gap={includeGap}>
  <slot />
</thead>
